import {
  CloseOutlined,
  CopyOutlined,
  DeleteOutlined,
  PullRequestOutlined,
} from '@ant-design/icons';
import { Button, Drawer, Popconfirm, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { ToolBarHeaderMap } from '../../../constants';
import FieldProperties from './FieldProperties';
import './style.less';

const PropertiesPanel = ({
  questions,
  selectedQuestion,
  updateProperties,
  visible,
  setVisible,
  cloneElement,
  deleteElement,
  openLogics,
}) => {
  const isDesktop = useMediaQuery({ minWidth: 992 });

  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { t } = useTranslation(['builder', 'translation']);

  const headText = () => {
    if (selectedQuestion && selectedQuestion.type) {
      const toolbarHeader = ToolBarHeaderMap[selectedQuestion.type] ?? ToolBarHeaderMap['DEFAULT'];
      return `${t('builder:stagingArea.edit', 'Edit')} ${t(
        `stagingArea.propertyTitle.${toolbarHeader.key}`,
        `${toolbarHeader.default}`,
      )}`;
    }
    return null;
  };

  const panelTitle = (
    <>
      <div className="panel-title">
        <Typography.Text className="sub-title">{headText()}</Typography.Text>
        {isMobile && <CloseOutlined onClick={() => setVisible(false)} />}
      </div>
      {isMobile && (
        <div
          style={isMobile ? { marginTop: 15 } : {}}
          className="action-buttons"
          onClick={(e) => e.stopPropagation()}
        >
          <Button
            onClick={() => openLogics(selectedQuestion.questionId)}
            title="Open logic"
            icon={<PullRequestOutlined />}
          >
            Open logic
          </Button>
          <Button
            icon={<CopyOutlined />}
            onClick={() => cloneElement(selectedQuestion.questionId)}
            title="copy"
          >
            {t('translation:duplicate', 'Duplicate')}
          </Button>
          <Popconfirm
            title={
              <div style={{ maxWidth: '400px' }}>
                <h4>{t('builder:stagingArea.delete.label')}</h4>
                {t('builder:stagingArea.delete.description')}
              </div>
            }
            onConfirm={() => deleteElement(selectedQuestion.questionId)}
            okText={t('translation:common.yes', 'Yes')}
            cancelText={t('translation:common.no', 'No')}
            placement="left"
            arrowPointAtCenter
          >
            <Button icon={<DeleteOutlined />} type="primary" danger title="delete">
              {t('translation:delete.text', 'Delete')}
            </Button>
          </Popconfirm>
        </div>
      )}
    </>
  );

  return (
    <div className="Properties-panel">
      <Drawer
        title={panelTitle}
        placement="right"
        // closable={true}
        visible={selectedQuestion && visible}
        onClose={setVisible}
        getContainer={false}
        mask={false}
        width={isMobile ? '100%' : 350}
        className="fields-panel"
        // style={{ position: 'fixed', top: isDesktop ? 140 : 188 }}
        headerStyle={{ padding: '20px 20px 16px' }}
        contentWrapperStyle={{
          boxShadow: !isDesktop ? 'rgba(0, 0, 0, 0.16) 0px 1px 4px' : 'none',
          borderLeft: !isDesktop ? 'none' : '2px solid #ecebee',
        }}
        bodyStyle={{ padding: '12px 20px' }}
        closeIcon={isMobile ? null : <CloseOutlined />}
      >
        {selectedQuestion && (
          <FieldProperties
            key={selectedQuestion.questionId}
            questions={questions}
            question={selectedQuestion}
            questionId={selectedQuestion?.questionId}
            update={updateProperties}
          />
        )}
      </Drawer>
    </div>
  );
};

export default PropertiesPanel;
